"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TopRowWrapper = exports.SelectableCardContentBiggerSpacing = exports.SelectableCardContent = exports.InfoChip = exports.ContentWithSeparator = exports.ContentRowWrapper = exports.ContentRight = exports.Content = void 0;
var _mui = require("@ori-ui/mui");
const columnFlexStyles = (theme)=>({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    });
const SelectableCardContent = exports.SelectableCardContent = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        ...columnFlexStyles(theme),
        justifyContent: 'stretch',
        justifySelf: 'stretch'
    };
});
const SelectableCardContentBiggerSpacing = exports.SelectableCardContentBiggerSpacing = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        ...columnFlexStyles(theme),
        gap: theme.spacing(3),
        justifyContent: 'stretch',
        justifySelf: 'stretch'
    };
});
/** Wrapper for the logo images of couriers, shipping offer chip flags, etc. */ const TopRowWrapper = exports.TopRowWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        gap: theme.spacing(2)
    };
});
/** The name of courier or place, also usually contains the price on the right side. */ const ContentRowWrapper = exports.ContentRowWrapper = (0, _mui.styled)('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start'
});
const Content = exports.Content = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return columnFlexStyles(theme);
});
const ContentRight = exports.ContentRight = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        ...columnFlexStyles(theme),
        alignItems: 'flex-end'
    };
});
const ContentWithSeparator = exports.ContentWithSeparator = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        ...columnFlexStyles(theme),
        borderTop: "1px solid ".concat(theme.palette.grey[300]),
        paddingTop: theme.spacing(3)
    };
});
const InfoChip = exports.InfoChip = (0, _mui.styled)(_mui.Chip)((param)=>{
    let { theme } = param;
    return {
        backgroundColor: theme.palette.grey[200]
    };
});
